/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import { colorAt } from 'solis/theme/palette';


export default class GalaxyUser extends Logic
{
  constructor (galaxy, user)
  {
    super(galaxy);

    this.user = user;
  }


  getName ()
  {
    return this.getScore().cass.name;
  }


  getColor ()
  {
    return colorAt(this.getScore().cass.theme);
  }


  getScore ()
  {
    return this.object.getScore(this.user);
  }


};
